import Trees from "./Trees";

export * from "./Cannabis";
export * from "./Caravan";
export * from "./FlameKindling";
export * from "./Flower2";
export * from "./Leaf";
export * from "./MountainSnow";
export * from "./Tent";
export * from "./TentTree";
export * from "./TreeDecidous";
export * from "./TreePalm";
export * from "./TreePine";
export * from "./Trees";

export const Nature = {
  Trees,
};
